import { render } from "./PricingAccordionComponent.vue?vue&type=template&id=ffe1fe28&scoped=true&ts=true"
import script from "./PricingAccordionComponent.vue?vue&type=script&lang=ts"
export * from "./PricingAccordionComponent.vue?vue&type=script&lang=ts"

import "./PricingAccordionComponent.vue?vue&type=style&index=0&id=ffe1fe28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe1fe28"]])

export default __exports__